module.exports = __webpack_public_path__ + "img/BusinessPlan-Icon.781ec10f.svg";